module.exports = __webpack_public_path__ + "img/impiantorosso.49ea484f.png";